import { Injectable } from '@angular/core';

import {  Firestore,serverTimestamp, collection, query, where, orderBy, getDocs, addDoc, doc, getDoc, setDoc, updateDoc, limitToLast } from '@angular/fire/firestore';
import * as _ from 'lodash';
import { reject } from 'lodash';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class AnswerService {
  constructor(private firestore: Firestore,private helpers: HelperService,) { }

  async createAnswer(answer:any){
    //get the refrence of answer collection
    
    let id=  answer?.question+'_'+answer?.instance
    if(!id){
      id="abcdesknkladmw"+Date.now()   //// in any case if there is no instance and question id then it will add id as this 
    }
    // const exist=  await this.getAnswerById(id)
    // if(!exist || answer?.quizType=='assessment'){///if doesn't exist then write it 
      var answerRef = doc(this.firestore,'answers', id)
      const createdOn =serverTimestamp();
      var answerObject = {... answer,                
        createdOn: createdOn,
        updatedOn: createdOn
      };
      setDoc(answerRef, answerObject)
      .then((doc) => {
        // console.log("added sucessfully", doc);
      })
      .catch((err) => {
        console.log(err);
      });
    //  }
    //  else{

    //   var answerRef = doc(this.firestore,'answer_stats', id)
    //   const createdOn =serverTimestamp();
    //   var answerObject = {... answer,                
    //     createdOn: createdOn,
    //     updatedOn: createdOn
    //   };    
    //   setDoc(answerRef, answerObject)
    //   .then((doc) => {
    //     // console.log("added sucessfully", doc);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    //  }
    }


  async getAnswerById(id: any) {

    const docRef = doc(this.firestore, "answers", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      // console.log("Document data:", docSnap.data());
      return true
    } else {
      // docSnap.data() will be undefined in this case
      // console.log("No such document!");
      return false;
    }
  }
  getAnswer(instance:any,singlePage:any = null){
    return new Promise((resolve, reject) => {
      let answers:any=[]
      const answerQuery = query(collection(this.firestore, 'answers'), where('instance', '==', instance), orderBy('createdOn'))
      getDocs(answerQuery).then(snapshot => {
        snapshot.forEach(doc=>{
          let answer:any = doc.data();
          answer['id'] = doc.id;
          if(singlePage=='singlePage'){
            answers.push(answer.question)
          }else{
            answers.push(answer)
          }
        })
        resolve(answers)
      }).catch(err=>{
        reject(err)
      })
    })
  }


  //adding all displayed questions on answers collection with answerStatus = 'n' and docId = instanceId_questionId and relatedInstanceId
  addQuestionsInAnswersCollection(questions: any,relatedInstanceId:any,instanceId:any,quizId:any,playerId:any) {
    const createdOn = serverTimestamp();
    questions.forEach((docs:any) => {
      var docRef:any = doc(this.firestore, "answers", instanceId+'_'+docs.questionId);
      var newAnswersData = {
        // id: instanceId+'_'+docs.questionId,
        question: docs.questionId,
        refPlayerId: playerId,
        relatedInstanceId:relatedInstanceId,
        answerStatus:'n',
        createdOn,
      }
      setDoc(docRef, newAnswersData)
        .then((doc) => {
          // console.log("added sucessfully");
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }
   //update answerStatus
   public updateAnswerStatusinAnswersCollection(answer:any) {
    return new Promise((resolve, reject) => {
      let docRef = doc(this.firestore,'answers',answer.instance+'_'+answer.question) //answers
      const createdOn =serverTimestamp();
      var answerObject = {... answer,
      createdOn: createdOn,
      answerStatus:'c',
      updatedOn: createdOn
      };
      updateDoc(docRef,answerObject)
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //checking quiz completed or not
  public quizCompletedOrNot(instanceId:any,playerId:any,xOutOfY:any){
    return new Promise((resolve, reject) => {
        //get instance details by instance id
        let docRef = doc(this.firestore,'instances', instanceId);
        getDoc(docRef).then((doc:any) => {
          //checking instances collection completed true/false
          let completed:any

          if(doc.data()){
           completed = doc.data().completed

          }
          if(completed && xOutOfY){
            var quizCompleted:any = true;
          } else {
            var quizCompleted:any = false;
          }
          resolve(quizCompleted)
      })
      }).catch(err => {
        reject(err)
      })
  }

  checkRelatedInstanceId(questions:any,relatedInstanceId:any,instanceId:any,playerId:any){
    return new Promise((resolve, reject) => {
      let answersData:any = [];
      let nQuestions:any = [];
      let otherQuestions:any = [];
      const answerQuery = query(collection(this.firestore, 'answers'),where('relatedInstanceId','==',relatedInstanceId),where('refPlayerId','==',playerId))
      getDocs(answerQuery).then(snapshot => {
        snapshot.forEach(doc=>{
          if(doc.data()){
            answersData.push(doc.data())
          }
        });
        questions.forEach((element:any) => {
          let answer = _.find(answersData, {'question': element.questionId})
          if (answer) {
            if (answer.answerStatus == "n") 
              nQuestions.push(element)
          } else {
            otherQuestions.push(element)
          }
        });
        questions = nQuestions.concat(otherQuestions)
        resolve(questions)
      }).catch(err=>{
        reject(err)
      })
    })
  }
  getAnswerByInstanceAndQuestionId(instanceId:any,questionId:any){
    return new Promise((resolve, reject) => {
      let answerObj:any={}
      let answerQuery:any = query(collection(this.firestore,'answers'),where('instance','==',instanceId),where('question','==',questionId)) //answers
      getDocs(answerQuery).then(snapshot => {
        snapshot.forEach(doc=>{
          if(doc.data()){
            let data:any = doc.data();
            answerObj={
              ...data,
              id : doc.id
            }
            resolve(answerObj)
          }
        })
      }).catch((err:any) =>{
        reject(err)
      })
    });
  }
  updateAnswerData(answerObj:any,answerId:any){
    return new Promise((resolve, reject) => {
      let docRef = doc(this.firestore,'answers',answerId) //answers
      updateDoc(docRef,answerObj)
        .then((result) => {
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getAllReviewRequest(liveQuizId:any,requestedAnswer:any){
    return new Promise((resolve, reject) => {
      let answerObj:any={}
      let listOfanswerObj:any=[]
      let answerQuery:any = query(collection(this.firestore,'answers'),where('liveQuizId','==',liveQuizId),where('question','==',requestedAnswer.questionId),where('answer','array-contains',requestedAnswer.ans)) //answers
      getDocs(answerQuery).then(snapshot => {
        snapshot.forEach(doc=>{
          if(doc.data()){
            let data:any = doc.data();
            answerObj={
              ...data,
              id : doc.id
            }
            listOfanswerObj.push(answerObj)
          }
        })
        resolve(listOfanswerObj)
      }).catch((err:any) =>{
        reject(err)
      })
    });
  }

  getAnswerStatsById(answerObj:any){
    return new Promise((resolve,reject)=>{
      let ref = doc(this.firestore,'answer_stats',answerObj.instance + "_" + answerObj.question)
      getDoc(ref).then(result=>{
        resolve(result.data())
      }).catch(err=>{
        reject(err)
      })
    })
  }

  createNonLiveDrsDoc(questionDoc:any,projectSetting:any , pending=false , questionNo:any=0 , docID:any=null){
    return new Promise(async (resolve, reject) => {
      let docId
      if(!docID){ 
        docId= this.helpers.uuidv4()
      }else{
        docId=docID
      }
      
      let data:any = {
        questionNo:pending?questionNo:-1,
        quizId : questionDoc.refQuizId,
        contentId : questionDoc.refContentId?questionDoc.refContentId:"",
        accountId : questionDoc.refAccountId?questionDoc.refAccountId:"",
        drsStartDateTime: projectSetting.drsStartDateTime,
        drsEndDateTime: projectSetting.drsEndDateTime,
        id: docId,
        status: pending?'pending':'reviewed', // creator didn't submit or save the data
        createdOn: serverTimestamp(),
      }
      if(projectSetting && projectSetting.nonLivePin && projectSetting.nonLivePin!=''){
        data['nonLivePin'] = projectSetting.nonLivePin
      }
      let liveQuizRef = doc(this.firestore, 'nonLiveDrs', docId);
      setDoc(liveQuizRef, data, {merge:true}).then((result) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
        console.log("err=>",err)
      });
    })
  }
  updateNonLiveDrsDoc(docId:any,data:any){
    return new Promise((resolve, reject) => {
      data.updatedOn =serverTimestamp()
      let docRef = doc(this.firestore, 'nonLiveDrs', docId);
      setDoc(docRef,data,{merge:true}).then(result => {
        resolve(result)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getAnswerByKeyAndValue(key:any,value:any){
    return new Promise((resolve, reject) => {
      let answers:any=[]
      const answerQuery = query(collection(this.firestore, 'answers'), where(key, '==', value))
      getDocs(answerQuery).then(snapshot => {
        snapshot.forEach(doc=>{
          let answer:any = doc.data();
          answer['id'] = doc.id;
          answers.push(answer)
        })
        resolve(answers)
      }).catch(err=>{
        reject(err)
      })
    })
  }

  getAnswerByDateRange(quizId:any,key:any,value:any,startTime:any,endTime:any){
    return new Promise((resolve, reject) => {
      let answers:any=[]
      const answerQuery = query(collection(this.firestore, 'answers'), where('quiz', '==' , quizId), where(key, '==' ,value ), where('createdOn', '>=', startTime),where('createdOn', '<=', endTime))
      getDocs(answerQuery).then(snapshot => {
        snapshot.forEach(doc=>{
          let answer:any = doc.data();
          answer['id'] = doc.id;
          answers.push(answer)
        })
        resolve(answers)
      }).catch(err=>{
        reject(err)
      })
    })
  }

  getAnswerByDateRangePlayerLed(quizId:any,key:any,value:any,startTime:any,endTime:any){
    return new Promise((resolve, reject) => {
      let answers:any=[]
      const answerQuery = query(collection(this.firestore, 'answers'), where('quiz', '==' , quizId), where(key, '==' , value), where('drsRaisedOn', '>=', startTime),where('drsRaisedOn', '<=', endTime),orderBy('drsRaisedOn'))
      getDocs(answerQuery).then(snapshot => {
        snapshot.forEach(doc=>{
          let answer:any = doc.data();
          answer['id'] = doc.id;
          answers.push(answer)
        })
        resolve(answers)
      }).catch(err=>{
        reject(err)
      })
    })
  }



  savedDrs(docId:any, questionId:any, data:any){
    return new Promise(async (resolve, reject) => {
      let liveQuizRef = doc(this.firestore, 'nonLiveDrs', docId, 'answerReview', questionId);
      setDoc(liveQuizRef, data, {merge:true}).then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
        console.log("err=>",err)
      });
    })
  }

  // // Function to fetch non-live answer reviewed data for a specific quizId
  async getNonLiveAnswerReviewedData(quizId: any) {
    try {
      const nonLiveDocsRef = collection(this.firestore, 'nonLiveDrs');
      const nonLiveDrsQueryRef = query(nonLiveDocsRef, where('quizId', '==', quizId), orderBy('createdOn', 'desc'));
      const docsSnapshot = await getDocs(nonLiveDrsQueryRef);
      const nonLiveDocData:any = {};
      if (docsSnapshot.size > 0) {
        const nonLiveDocPromises = docsSnapshot.docs.map(async (doc) => {
          const nonLiveData = doc.data();

          // Fetch answer review data for the current non-live document
          const answerReviewData = await this.getAnswerReviewData(doc.id);

          // Combine non-live data and answer review data
          const combinedData = { ...nonLiveData, answerReviewData };

          // Store the combined data in the object using the document ID as the key
          nonLiveDocData[doc.id] = combinedData;
        });
  
        // Wait for all non-live documents' answer review data to resolve
        await Promise.all(nonLiveDocPromises);
        return nonLiveDocData;

      } else {
        // If no documents found for the quizId, return null
        return null;
      }
    } catch (err) {
      console.error("Error fetching non-live answer reviewed data:", err);
      throw err; // Rethrow the error to the caller.
    }
  }

  // Function to fetch answer review data for a specific non-live document
  async getAnswerReviewData(nonLiveDocId: any) {
    try {
      const answerReviewData:any = [];
      const answerReviewRef = collection(this.firestore, 'nonLiveDrs', nonLiveDocId, 'answerReview');
      const answerReviewSnapshot = await getDocs(answerReviewRef);
  
      answerReviewSnapshot.forEach((doc) => {
        answerReviewData.push(doc.data());
      });
  
      return answerReviewData;
    } catch (err) {
      console.error("Error fetching answer review data:", err);
      throw err; // Rethrow the error to the caller.
    }
  }

  async getNonLiveReviewDataById(docId: any) {
    return new Promise((resolve,reject)=>{
      let ref = doc(this.firestore, 'nonLiveDrs', docId);
      getDoc(ref).then(result=>{
        resolve(result.data())
      }).catch(err=>{
        reject(err)
      })
    })
  }
}
